
export const REMAINING_TERM_METRIC_CODE = 'TS_KOS_RT';

export const TearsheetMetricCodes = [
  "Company Overview",
  "Investment Thesis",
  "Significant Developments",
  "Volume Throughput",
  "LTM Revenue",
  "LTM EBITDA",
  "LTM CAPEX",
  "Net Debt",
  "Net Debt/ EBITDA",
  "Current Production (Mcfepd)",
  "% Gas",
  "Proved Reserves (Bcfe)",
  "% Gas (Proved Reserves)",
  "Current Production (Boepd)",
  "% Liquids",
  "Proved Reserves (Mboe)",
  "% Liquids (Proved Reserves)",
  "Revenue",
  "EBITDA",
  "Equity Value",
  "Cash Balance",
  "Employee Headcount",
  "Wells Consented",
  "Capex Committed",
  "Remaining Term",
  "PDP PV-10 + Hedges PV-2",
  "PDP PV-10 + Hedges PV-2 / Net Debt",
  "PMT Review",
  "Compliance Review",
  "Client Service Review"
];

export const tearsheetNetGrossRatio: any = {
  'QEP VI': { netMoic: 0.78320907749084600000, netIrr: 0.73012632250763300000 },
  "QEP VI-C": { netMoic: 0.97755014034303900000, netIrr: 0.96753204988654300000 },
  "QEP VII": { netMoic: 0.80545033263699500000, netIrr: 0.73477783662172000000 },
  "QEP VII-C": { netMoic: 0.97868738749727700000, netIrr: 0.95004496484725200000 },
  "QEP VIII": { netMoic: 0.86357096262394600000, netIrr: 1. },
  "QEP VIII-C": { netMoic: 0.96375945737198200000, netIrr: 1. },
  "default": { netMoic: 1.0000000000000000000, netIrr: 1. }
};

export const TEARSHEET_DISPLAY_EXCLUDE_FUNDS: string[] = [
  "QEP IX Quest"
];

export const tearsheetFundCapitalMembers: string[] = [
  'QEP V', 'QEP V-C',
  'QEP VI', 'QEP VI-C',
  'QEP VII', 'QEP VII-C',
  'QEP VIII', 'QEP VIII-C',
  'QLCP I', 'QLCP I-C',
  'QCS II', 'QCS II-C',
  'QCS-II', 'QCS-II-C',
  'FCV',
  'QCO I',
  "QEP IX","QEP IX-O"
];